export enum EntityType {
  Individual = 'INDIVIDUAL',
  LegalEntity = 'LEGAL_ENTITY'
}
